import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Checkbox } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './PrivacyPolicyCheckbox.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PrivacyPolicyCheckbox = function PrivacyPolicyCheckbox(props) {
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    children: /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({}, props), {}, {
      label: /*#__PURE__*/_jsxs(_Fragment, {
        children: ["\u0421\u043E\u0433\u043B\u0430\u0448\u0430\u044E\u0441\u044C \u043D\u0430", ' ', /*#__PURE__*/_jsx("a", {
          className: styles['link'],
          href: "/legal-documents/politika_konfidencialnosti_0/",
          target: "_blank",
          children: "\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445"
        })]
      })
    }))
  });
};